export default {
  updateEmailSent: (state, sent) => {
    state.quotation.emailSent = sent;
    localStorage.setItem(
      "emailSent",
      JSON.stringify(sent)
    );
  },
  updateLocalQuotation: (state, payload) =>
    localStorage.setItem(
      payload.storeItemName,
      JSON.stringify(payload.storeItemObject)
    ),
  updateSimulationTable: function(state, payload) {
    const { simulation } = state;
    simulation.insurers.list.map(insurer => {
      insurer.id === payload.id ? (insurer.table = payload.data) : insurer;
    });
  },
  updateSimulationStarted: function(state, set) {
    state.simulation.started = set;
  },
  updateSimulationValue: function(state, payload) {
    state.simulation.insurers.list.map(insurer =>
      insurer.id === payload.id ? (insurer.value = payload.value) : insurer
    );
    if (!state.simulation.set) {
      state.simulation.set = true;
    }
  },
  updateSimulationState: (state, simulation) => (state.simulation = simulation),
  updateSimulationAge: (state, age) => (state.simulation.age = age),
  updateQuotationState: (state, quotation) => (state.quotation = quotation),
  updateSimulationSet: (state, set) => (state.simulation.set = set),
  updateProtectionsValue: function(state, value) {
    state.quotation.user.financialData.protectionsValue = value;
  },
  updateSelectedInsurer: function(state, insurer) {
    state.quotation.started = true;
    state.quotation.user.financialData.selectedInsurer = insurer;
    
    localStorage.setItem(
      "localSimulationState",
      JSON.stringify(state.simulation)
    );
    localStorage.setItem(
      "quotationStarted",
      JSON.stringify(true)
    );
    localStorage.setItem(
      "user",
      JSON.stringify(state.quotation.user)
    );

  },
  updateQuotationUser: (state, user) =>
    (state.quotation.user = user),
  updateQuotationStarted: (state, started) =>
    (state.quotation.started = started),
  updateQuotationFinished: (state, finished) =>
    (state.quotation.finished = finished),
  updateQuotationStep: (state, step) => (state.quotation.step = step),
  updateQuotationProgress: (state, progress) =>
    (state.quotation.progress = progress),
  updateUserState: (state, payload) => 
    (state.quotation.user[payload.group][payload.field] = payload.value),
  decrementQuotationStep: state => --state.quotation.step,
  incrementQuotationStep: state => {
    state.quotation.progress = state.quotation.step + 1;
    ++state.quotation.step;
    localStorage.setItem(
      "quotationStepProgress",
      JSON.stringify({
        step: state.quotation.step,
        progress: state.quotation.progress
      })
    );
  },
  addNewBeneficiary: state =>
    state.quotation.user.financialData.beneficiares.push({
      name: "",
      birthDate: "",
      kinship: "",
      participation: ""
    }),
  removeBeneficiary: (state, index) =>
    state.quotation.user.financialData.beneficiares.splice(index, 1),
  updateSentDB: (state, sent) => state.quotation.sentToDataBase = sent,
  updateLightbox: (state, payload) => {
    state.lightbox = {
      show: payload.show,
      title: payload.title,
      content: payload.content
    };
  }
};
